import { render, staticRenderFns } from "./TeamContactCard.vue?vue&type=template&id=2d781b91&"
import script from "./TeamContactCard.vue?vue&type=script&lang=ts&"
export * from "./TeamContactCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports